/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ApplicationsService } from './services/applications.service';
import { AppsService } from './services/apps.service';
import { LicenseServersService } from './services/license-servers.service';
import { CustomersService } from './services/customers.service';
import { UsersService } from './services/users.service';
import { ApiService } from './services/api.service';
import { OpenApiService } from './services/open-api.service';
import { IdPsService } from './services/id-ps.service';
import { ConfigurationService } from './services/configuration.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ApplicationsService,
    AppsService,
    LicenseServersService,
    CustomersService,
    UsersService,
    ApiService,
    OpenApiService,
    IdPsService,
    ConfigurationService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
